import {EmailMakerSaveErrorCode} from '@EmailMakerReact/lib/email-maker-storage-library';
import type {EmailMakerSaveErrorState} from '@EmailMakerReact/email-maker-react.types';

export interface EmailMakerSaveErrorPopoverProps {
  saveError: EmailMakerSaveErrorState | null;
  isOpen: boolean;
  onClose: () => void;
}

/** The conflict popover owns EXISTING_SAVE_DATA; this popover shows only errors carrying renderable detail (invalid links or a backend message). */
export function hasDisplayableSaveError(saveError: EmailMakerSaveErrorState | null): saveError is EmailMakerSaveErrorState {
  if (saveError === null || saveError.code === EmailMakerSaveErrorCode.EXISTING_SAVE_DATA) {
    return false;
  }
  return (saveError.invalidUrls !== undefined && saveError.invalidUrls.length > 0) || (saveError.message !== undefined && saveError.message.length > 0);
}
